// src/app/components/Moodle/MoodleButton.jsx
import React, { useState } from 'react';
import { useAuth } from '../../modules/auth/core/Auth';
import { getUserDataById } from '../../modules/apps/user-management/users-list/core/_requests';
import MoodleRegistrationDialog from './MoodleRegistrationDialog';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const MoodleButton = ({ className, children, style = {} }) => {
  const { auth, currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [moodleStatus, setMoodleStatus] = useState(null);

  const token = auth?.api_token || null;
  const user = currentUser?.user || currentUser || null;

  // FUNCIÓN PARA OBTENER DATOS COMPLETOS DEL USUARIO
  const fetchUserFullData = async () => {
    if (!user?.id) {
      console.log('[MoodleButton] No hay ID de usuario');
      return null;
    }
    
    try {
      console.log('[MoodleButton] Obteniendo datos completos del usuario ID:', user.id);
      const response = await getUserDataById(`id=${user.id}`);
      
      // LA RESPUESTA TIENE ESTRUCTURA { success: true, data: { ... } }
      console.log('[MoodleButton] Respuesta completa:', response);
      
      // EXTRAER LOS DATOS DE LA ESTRUCTURA CORRECTA
      const userData = response?.data || response || {};
      const userComplemento = userData?.UserComplemento || {};
      
      console.log('[MoodleButton] UserData:', userData);
      console.log('[MoodleButton] UserComplemento:', userComplemento);
      console.log('[MoodleButton] primer_nome:', userComplemento?.primer_nome);
      console.log('[MoodleButton] primer_apelido:', userComplemento?.primer_apelido);
      console.log('[MoodleButton] numero_doc:', userComplemento?.numero_doc);
      
      return {
        email: userData?.email || user.email || '',
        firstName: userComplemento?.primer_nome || '',
        lastName: userComplemento?.primer_apelido || '',
        documentId: userComplemento?.numero_doc || '',
        fullData: userData
      };
    } catch (error) {
      console.error('[MoodleButton] Error obteniendo datos del usuario:', error);
      return null;
    }
  };

  const handleClick = async () => {
    if (!token) {
      console.warn('[MoodleButton] No hay token en el contexto');
      alert('No has iniciado sesión. Por favor, inicia sesión primero.');
      window.location.href = '/login';
      return;
    }

    if (!user) {
      alert('No se encontró información del usuario.');
      return;
    }

    setLoading(true);
    
    try {
      // OBTENER DATOS COMPLETOS DEL USUARIO
      let userInfo = await fetchUserFullData();
      
      // Si no se pudieron obtener datos completos, usar los datos del contexto
      if (!userInfo || !userInfo.firstName) {
        const userComplemento = user?.UserComplemento || {};
        userInfo = {
          email: user?.email || '',
          firstName: userComplemento?.primer_nome || '',
          lastName: userComplemento?.primer_apelido || '',
          documentId: userComplemento?.numero_doc || '',
          fullData: user
        };
      }
      
      if (!userInfo.email) {
        alert('No se encontró el correo electrónico del usuario.');
        setLoading(false);
        return;
      }

      const { email, firstName, lastName, documentId } = userInfo;
      
      console.log('[MoodleButton] Datos para verificación FINALES:', { email, firstName, lastName, documentId });

      const url = `${API_BASE_URL}/moodle/user/exists?email=${encodeURIComponent(email)}&documentId=${encodeURIComponent(documentId)}`;
      console.log('[MoodleButton] Verificando existencia:', url);
      
      const response = await fetch(url, { 
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        } 
      });
      
      const result = await response.json();
      console.log('[MoodleButton] Resultado exists:', result);

      if (result.data?.exists) {
        // SSO DIRECTO
        const urlResponse = await fetch(
          `${API_BASE_URL}/sso/moodle-url`,
          { 
            headers: { 
              'Authorization': `Bearer ${token}`,
              'Accept': 'application/json'
            } 
          }
        );
        
        if (!urlResponse.ok) {
          throw new Error(`Error SSO: ${urlResponse.status}`);
        }
        
        const urlData = await urlResponse.json();
        const moodleUrl = urlData.moodle_url;
        
        if (!moodleUrl) {
          throw new Error('No se pudo obtener la URL de Moodle');
        }
        
        console.log('[MoodleButton] Abriendo Moodle:', moodleUrl);
        window.open(moodleUrl, '_blank');
      } else {
        // PASAR LOS DATOS COMPLETOS AL DIÁLOGO DE REGISTRO
        const registerData = {
          exists: false,
          registerUrl: result.data?.registerUrl,
          userData: {
            email: email,
            firstName: firstName,
            lastName: lastName,
            documentId: documentId
          }
        };
        
        console.log('[MoodleButton] Datos para diálogo de registro:', registerData);
        
        setMoodleStatus(registerData);
        setShowDialog(true);
      }
    } catch (error) {
      console.error('[MoodleButton] Error:', error);
      alert(`Error al conectar con la plataforma de formación virtual: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async () => {
    // Obtener los datos del usuario que están en moodleStatus
    const email = moodleStatus?.userData?.email || user?.email || '';
    const firstName = moodleStatus?.userData?.firstName || user?.UserComplemento?.primer_nome || '';
    const lastName = moodleStatus?.userData?.lastName || user?.UserComplemento?.primer_apelido || '';
    const documentId = moodleStatus?.userData?.documentId || user?.UserComplemento?.numero_doc || '';

    try {
      const url = `${API_BASE_URL}/moodle/user/register-url?email=${encodeURIComponent(email)}&firstname=${encodeURIComponent(firstName)}&lastname=${encodeURIComponent(lastName)}&documentId=${encodeURIComponent(documentId)}`;
      console.log('[MoodleButton] Registrando en:', url);
      
      const response = await fetch(url, { 
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        } 
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}`);
      }

      const data = await response.json();
      const registerUrl = data.data?.url || data.url;
      
      if (!registerUrl) {
        throw new Error('No se pudo obtener la URL de registro');
      }
      
      window.open(registerUrl, '_blank');
      setShowDialog(false);
    } catch (error) {
      console.error('[MoodleButton] Error registro:', error);
      alert('Error al generar la URL de registro.');
    }
  };

  return (
    <>
      <button 
        onClick={handleClick} 
        disabled={loading} 
        className={className}
        style={style}
      >
        {loading ? 'Verificando...' : children || 'Ir a Formación Virtual'}
      </button>
      
      {showDialog && moodleStatus && (
        <MoodleRegistrationDialog
          user={moodleStatus.userData || user}
          registerUrl={moodleStatus.registerUrl}
          onClose={() => setShowDialog(false)}
          onRegister={handleRegister}
        />
      )}
    </>
  );
};

export default MoodleButton;